module.exports = __webpack_public_path__ + "static/img/ussc-first-icon.e4564690.png";